















































































import { Action } from "vuex-class";
import { ActionMethod } from "vuex";
import { Component, Prop, Vue } from "vue-property-decorator";
import { LabeledText } from "@/types/types";
import { ReferralTriageDetailsModel } from "@/types/aznconnect_api";
import InformationCard from "@/components/InformationCard.vue";
import DefaultPatientSearchDialog from "@/components/espoed/DefaultPatientSearchDialog.vue";
import { PersonFormatter } from "@/services/personFormatter";

@Component({
  components: {
    "information-card": InformationCard,
    "default-patient-search-dialog": DefaultPatientSearchDialog,
  },
})
export default class PatientInformationView extends Vue {
  @Prop()
  advancedMode!: boolean;

  @Prop({ default: null })
  referral!: any;

  @Prop({ default: null })
  referralState!: string;

  @Prop({ default: false })
  isReadOnly!: boolean;

  @Prop({ default: false })
  allowLinkPatientNumber!: boolean;

  @Prop({ default: false })
  allowSetReferralState!: boolean;

  @Prop({ default: "" })
  patientNumber!: string;

  isEditingPatientNumber: boolean = false;

  textBelowLabel(label: string) {
    if (label === "Events" || label === "Extra informatie") {
      return true;
    }

    return false;
  }

  @Action("resolveReferral", { namespace: "espoed" })
  resolveReferralAction!: ActionMethod;

  resolveReferral(): void {
    this.resolveReferralAction(this.referral.Reference);
  }

  get patientInformationValues(): Array<LabeledText> {
    const formatDate = Vue.filter("formatDate");
    const values: Array<LabeledText> = [];
    const referralModel = this.referral; // as ReferralTriageDetailsModel;

    let birthDate = "";
    if (referralModel.PatientBirthDate) {
      birthDate = formatDate(referralModel.PatientBirthDate);
      if (referralModel.PatientAge != null) {
        birthDate = birthDate + " (" + referralModel.PatientAge + " jaar)";
      }
    }
    values.push(new LabeledText("Geboortedatum", birthDate || "-"));
    values.push(new LabeledText("BSN", referralModel.PatientBSN || "-"));
    values.push(
      new LabeledText(
        "Telefoonnummer",
        this.referral.PatientPhoneNumber || "-",
      ),
    );

    values.push(
      new LabeledText(
        "Adres",
        `${referralModel.PatientAddressLine1 || "-"}<br/>
         ${referralModel.PatientAddressLine2 || "-"}<br/>
         ${referralModel.PatientAddressLine3 || "-"}`,
      ),
    );

    values.push(
      new LabeledText("Contactpersoon", referralModel.ContactName || "-"),
    );

    values.push(
      new LabeledText(
        "Relatie",
        referralModel.ContactRoleTypeDisplayName || "-",
      ),
    );

    values.push(
      new LabeledText(
        "Contactpersoon tel.",
        referralModel.ContactPhoneNumber || "-",
      ),
    );

    const practitioner = PersonFormatter.formatPractitioner(
      referralModel.GeneralPractitionerName,
      referralModel.GeneralPractitionerAgbCode,
    );
    values.push(new LabeledText("Huisarts", practitioner));

    values.push(
      new LabeledText(
        "Huisarts organisatie",
        referralModel.GeneralPractitionerOrganizationName || "-",
      ),
    );

    values.push(
      new LabeledText(
        "Huisarts tel.",
        referralModel.GeneralPractitionerPhoneNumber || "-",
      ),
    );

    return values;
  }
}
